export class ContentCountryLanguage {
  headingText: string;
  country: string;
  language: string;
  done: string;
  supportedCountry: string;
  defaultCountry: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['headingText']) {
        this.headingText = contentjson['headingText'];
      }
      if (contentjson['country']) {
        this.country = contentjson['country'];
      }
      if (contentjson['language']) {
        this.language = contentjson['language'];
      }
      if (contentjson['done']) {
        this.done = contentjson['done'];
      }
      if (contentjson['defaultCountry']) {
        this.defaultCountry = contentjson['defaultCountry'];
      } else {
        this.defaultCountry = 'us-en';
      }
      if (contentjson['supportedCountry']) {
        this.supportedCountry = contentjson['supportedCountry'];
      }
    }
  }
}
